import React, { useState } from 'react';
import { Button, Header, Input } from '../../components';
import Loading from '../../components/Loading';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useStateContext } from '../../contexts/ContextProvider';
import axiosClient from '../../axios-client';
import Alert from '../../components/Alert';
import { toast } from 'react-toastify';
import { GiCancel } from 'react-icons/gi';
import { IoIosSave } from 'react-icons/io';
import Select from 'react-select';
import { PiNotePencilBold } from 'react-icons/pi';
import MySelect from '../../components/MySelect';

const EditDevoir = ({ onClose, selectedDevoir }) => {
    const [loading, setLoading] = useState(false);

    const { token, setToken, user } = useStateContext();
    const [errors, setErrors] = useState(null);





    const [enseignants, setEnseignant] = useState([]);
    const [selectedEnseignant, setSelectedEnseignant] = useState(selectedDevoir.enseignant);
    const [inputValueEnseignant, setValueEnseignant] = useState('');


    const [devoir, setDevoir] = useState({
        devoirId: selectedDevoir.id,
        classe: '',
        matiere: '',
        heureDebut: selectedDevoir.heureDebut,
        heureFin: selectedDevoir.heureFin,
        enseignant: selectedEnseignant.id,
        dateDevoir: selectedDevoir.dateDevoir,
        trimestre: null

    });


    const handleChangeEnseignant = value => {
        setSelectedEnseignant(value);
        setDevoir({ ...devoir, enseignant: value.id });


    }

    const handleInputChangeEnseignant = value => {
        setValueEnseignant(value);
    };
    // handle selection


    const navigate = useNavigate();


    const getEnseignants = () => {
        axiosClient.get('/enseignants')
            .then((data) => {
                setEnseignant(data.data.enseignants);
            }).catch(err => {
                navigate('/500');
            })
    }



    useEffect(() => {
        setLoading(true);
        getEnseignants();
        setLoading(false);
    }, []);
    const onSubmit = () => {

        setErrors(null);
        setLoading(true);

        axiosClient.put('/devoir/update', devoir)
            .then((response) => {
                setLoading(false);
                setErrors(null);
                toast.success('Opération effectuée avec succès!', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
                onClose();
            }).catch(err => {
                const response = err.response;
                if (response.status === 401) {
                    setToken(null);
                }
                else {
                    if (response.status === 422) {
                        setErrors(response.data.errors);
                        setLoading(false);
                        toast.error('Une erreur est survenue!', {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                        });
                    } else {
                        if (response.status === 403) {
                            navigate('/403');
                        } else {
                            if (response.status === 404) {
                                navigate('/404');
                            }
                            else {
                                navigate('/500');
                            }
                        }
                    }

                }
            })
    }



    return (
        <>
            <div className=' fixed inset-0 h-full bg-black bg-opacity-25 backdrop-blur-sm  '>
                <div className='h-screen flex justify-center items-center'>
                    <div className='flex-col  max-h-screen overflow-y-auto bg-white lg:p-10 xl:p-10  p-2 md:p-10 w-auto md:w-1/2 lg:w-1/2 xl:w-1/2 rounded-xl'>
                        <div className=''>
                            <Header icon={<PiNotePencilBold />} title="Modifier un devoir"  titleAr="تحرير إختبار"/>
                        </div>
                        {errors &&
                            Object.keys(errors).map(key => (
                                <Alert key={key} message={errors[key][0]} />
                            ))
                        }

                        <>
                            <div className='flex flex-wrap md:flex-nowrap lg:flex-nowrap xl:flex-nowrap gap-2'>
                                <div className='flex-col w-full justify-evenly '>
                                    <div className='mr-2'>
                                        <Input label="Date" labelAr="التاريخ" type="date" value={devoir.dateDevoir} onChange={ev => setDevoir({ ...devoir, dateDevoir: ev.target.value })} required="required" />
                                    </div>
                                    <div className="flex-col w-full">
                                        <Input readOnly="readOnly" labelAr="القسم" label="Classe" type="text" value={selectedDevoir.classe.libelle} required="required" />
                                    </div>
                                    <div className="flex-col w-full">
                                        <Input readOnly="readOnly" label="Matière" labelAr="المادة" type="text" value={selectedDevoir.matiere.libelle} required="required" />
                                    </div>
                                    <div className="flex-col w-full">
                                        <MySelect label="Enseignant" labelAr="المصحح" placeholder="Enseignant" cacheOptions defaultOptions value={selectedEnseignant} getOptionLabel={e => e.nomTel} getOptionValue={e => e.id} options={enseignants} onInputChange={handleInputChangeEnseignant} onChange={handleChangeEnseignant} />
                                    </div>
                                </div>
                                <div className='flex-col w-full justify-evenly '>

                                    <div className="flex-col w-full">
                                        <Input readOnly="readOnly" label="Trimestre" labelAr="الفصل" type="text" value={selectedDevoir.trimestre.code} required="required" />
                                    </div>
                                    <div className='mr-2'>
                                        <Input label="Heure Debut" labelAr="بداية الوقت" type="time" value={devoir.heureDebut} onChange={ev => setDevoir({ ...devoir, heureDebut: ev.target.value })} required="required" />
                                    </div>
                                    <div className='mr-2'>
                                        <Input label="Heure Fin" labelAr="نهاية الوقت" type="time" value={devoir.heureFin} onChange={ev => setDevoir({ ...devoir, heureFin: ev.target.value })} required="required" />
                                    </div>
                                </div>
                            </div>
                        </>

                        <div className='flex  justify-end items-end'>
                            <div className=' flex gap-3 m-2  justify-between'>
                                {loading ? <Loading /> :
                                    <Button icon={<IoIosSave />} onClick={onSubmit} color="ml-1 bg-green-500" textColor="text-white" text="Enregistrer" />
                                }
                                <Button icon={<GiCancel />} onClick={() => onClose()} color="bg-red-500" textColor="text-white" text="Fermer" />
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </>
    )
}

export default EditDevoir